// extracted by mini-css-extract-plugin
module.exports = {"container":"advancedResearches_container__3gwdU","title":"advancedResearches_title__356vi","link":"advancedResearches_link__PODhN","containerLink":"advancedResearches_containerLink__ywSJ-","containerAdvancedResearches":"advancedResearches_containerAdvancedResearches__1QjdK"};
    if(module.hot) {
      // 1744882474955
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  